import Template from '../../component/Template.js';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';


import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function TeacherCourseMapping() {

    const [admissionYears, setAdmissionYears] = useState([]);
    const [admissionYear, setAdmissionYear] = useState(null);
    const [activeSemester, setActiveSemesterId] = useState(null);
    const [disciplinedata, setDisciplineData] = useState([]);
    const [issaved, setissaved] = useState(false);
    const [semester_id, setSemester] = useState([]);

    const [selectedUserOptions, setSelectedUserOptions] = useState({});
    const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);
    const [isFirstSubmit, setFirstSubmit] = useState(false);
    const [facultyMap, setFacultyMap] = useState({});

    const [selectedDisciplines, setSelectedDisciplines] = useState([]);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);

    const [ShowModal, setShowModal] = useState(false);
    const [getISDisciplineCounts, setISDisciplineCounts] = useState([]);
    const tableRef = useRef(null);




    const { http } = Api();
    const navigate = useNavigate();

    const isAuth = useAuth();

    if (isAuth === false) {

        navigate("/ino/");
    }

    let cid = localStorage.getItem("collegeid");

    useEffect(() => {
        const fetchActiveEvents = async () => {

            if (admissionYear?.value && semester_id?.value) {

                try {

                    const response = await http.get('getActiveEvents', {
                        params: { event_id: 30 }
                    });

                    const matchedEvent = response.data.find(event =>
                        event.admission_year === admissionYear.value &&
                        event.semester_id === semester_id.value &&
                        event.status === "active"
                    );

                    if (matchedEvent) {
                        setActiveSemesterId(matchedEvent.semester_id); // store active semester

                    } else {

                        setActiveSemesterId(null);
                    }
                } catch (error) {

                    setActiveSemesterId(null);


                }

            } else {

                setActiveSemesterId(null);

            }

        };

        fetchActiveEvents();
    }, [admissionYear, semester_id]);

    useEffect(() => {
        const fetchAdmissionYears = async () => {
            try {

                const response = await http.get('/College/getSFASideActiveAdmissionYear');
                const years = response.data
                    .filter(year => year.admission_year !== 2025)
                    .map((year) => ({
                        id: year.id,
                        value: year.admission_year,
                        label: year.admission_year
                    }));

                setAdmissionYears(years);
            } catch (error) {

                setAdmissionYears([]);

                toast.error("Error fetching admission years");
            }
        };
        fetchAdmissionYears();
    }, []);

    const handleAdmissionYearChange = (selectedOption) => {

        setAdmissionYear(selectedOption);
        setSelectedUserOptions({});
        setDisciplineData([]);


    };

    const handleSemesterChange = (selectedOption) => {

        setSemester(selectedOption);
        setSelectedUserOptions({});
        setDisciplineData([]);

    };


    useEffect(() => {

        const fetchData = async () => {

            try {
                const response = await http.get(`/College/getCollegeDisciplinesforINOprince`, {

                    params: {
                        college_id: cid,
                        semester_id: semester_id.value,
                        admission_year: admissionYear.value,
                    }
                });

                if (!(response?.data?.status_code === 'ERR5')) {
                    setDisciplineData(response.data);
                }
            }
            catch (error) {
                setSelectedUserOptions([]);
                setCollegeTeacherData([]);
                toast.error("Error fetching disciplines");
            }
        };

        if (admissionYear?.value && semester_id?.value) {

            fetchData();

        }

    }, [admissionYear, semester_id, issaved]);

    // useEffect(() => {
    //   const getCourseMappingStatusSummary = async () => {

    //     http.get('/College/getCourseMappingStatusSummary', {
    //       params: {

    //         college_id: cid,
    //         admissionyear: admissionYear.value,
    //         semester_id: semester_id.value,

    //       },
    //     }).then((response) => {

    //       setCourseMappingStatusSummaryData(response.data);

    //     }).catch((error) => {

    //       setCourseMappingStatusSummaryData([]);

    //     });
    //   };
    //   if (cid && admissionYear && semester_id.value) {

    //     getCourseMappingStatusSummary();
    //   }


    // }, [admissionYear, semester_id.value, issaved]);


    const handleUserChange = (selectedOption, discipline_name) => {

        setSelectedUserOptions(prev => ({
            ...prev,
            [discipline_name]: selectedOption || []
        }));

    };


    useEffect(() => {

        const fetchCollegeTeachersList = async () => {

            try {
                const response = await http.get(`/College/getCollegeTeacherIno`, {
                    params: {

                        college_id: cid,
                        admissionyear: admissionYear.value,
                        semester_id: semester_id.value,

                    },
                });

                setCollegeTeacherData(response.data);

                // Create a lookup dictionary to pass to backend
                const facultyMap = {};

                response.data.forEach(u => {
                    facultyMap[u.fac_id] = u;   // store full obj by fac_id
                });

                setFacultyMap(facultyMap);

                const selected = {};

                disciplinedata.forEach(discipline => {

                    const matchedUsers = response.data.filter(user =>
                        user.discipline?.some(d =>
                            d.discipline_id === discipline.discipline_id &&
                            d.discipline_type === discipline.college_course_type
                        )
                    );

                    if (matchedUsers.length > 0) {

                        selected[discipline.discipline_name] = matchedUsers.map(user => ({
                            value: user.user_id,
                            label: `${user.full_name} - ${user.fac_id} - ${user.mobile_number}`,
                            fac_id: user.fac_id
                        }));
                    }

                });

                setSelectedUserOptions(selected);

                //console.log("selectedUserOptions", selectedUserOptions);

            }
            catch (error) {

                setCollegeTeacherData([]);

                toast.error("Something went wrong");

            }
        };
        if (disciplinedata.length > 0) {

            fetchCollegeTeachersList();
        }

    }, [disciplinedata, issaved]);

    useEffect(() => {

        const getISDisciplineCounts = async () => {

            try {
                const response = await http.get('/College/ISDisciplineCounts', {
                    params: {
                        semester: semester_id.value,
                        admission_year: admissionYear.value,
                    }
                });

                setISDisciplineCounts(response.data);


            } catch (error) {

                getISDisciplineCounts([]);
                if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                    toast.error(error.response.data.message);
                }
                else {
                    console.error('Error fetching statistics:', error);
                    toast.error('Error fetching statistics');
                }

            }
        };


        if (admissionYear?.value && semester_id?.value) {
            getISDisciplineCounts();

        }
    }, [admissionYear, semester_id, issaved]);


    const handlefirstsubmit = () => {

        setFirstSubmit(!isFirstSubmit);

    }
    const handleSubmitData = (e) => {


        http.post('/College/PrincipalDisciplineApprove', {

            disciplines: selectedDisciplines,

        }).then((response) => {

            if (response.data.status_code === 'MSG3') {

                setissaved(!issaved);
                setShowModal(false);
                setSelectedDisciplines([]);
                setIsSelectAllChecked(!isSelectAllChecked);
                toast.success('Data saved successfully');

            } else {
                toast.error('Failed to save data');
                setissaved(!issaved);

            }
        }).catch((error) => {

            toast.error("Something went wrong");

        });
    };

    const handleCancel = () => {
        setShowModal(false);

    }

    const cancelForm = () => {
        window.location.reload();
    };


    const handleGeneratePDFNew = async () => {
        // setLoading(true);
        try {
            const response = await http.get('/College/isoPdfDownload', {
                params: {
                    college_id: cid,
                    admissionyear: admissionYear.value,
                    semester_id: semester_id.value,
                },
                responseType: 'blob', // Expect binary response
            });

            if (response && response.data) {
                // Create a URL for the downloaded file
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                // Set the file name and download the PDF
                link.setAttribute(
                    'download',
                    `${localStorage.getItem('username')}__Discipline_IS_Mapping - .pdf`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // setLoading(false);
                toast.success('PDF generated successfully');
            }
        } catch (error) {

            toast.error('Error generating PDF');

        }
    };

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            textAlign: 'left', // added

        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '180px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
            textAlign: 'left', // added

        }),

        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
                textAlign: 'left', // added

            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };

    const handleCheckboxChange = (discipline_id) => {

        if (selectedDisciplines.includes(discipline_id)) {
            // Deselect the student
            const filteredDisciplines = selectedDisciplines.filter(id => id !== discipline_id)
            setSelectedDisciplines(filteredDisciplines);

            if (filteredDisciplines.length === 0) {
                setIsSelectAllChecked(false);
            }

        } else {
            // Select the student
            setSelectedDisciplines([...selectedDisciplines, discipline_id]);
        }
    };

    const handleSelectAll = () => {

        const allSelected = !isSelectAllChecked;
        setIsSelectAllChecked(allSelected);

        if (allSelected) {
            // Select all students' apaarId
            const allStudentIds = disciplinedata
                .filter((DisciplinesDetails) => DisciplinesDetails?.mapped === "mapped")
                .map((DisciplinesDetails) => DisciplinesDetails?.discipline_id);
            setSelectedDisciplines(allStudentIds);

        } else {
            // Deselect all
            setSelectedDisciplines([]);
        }
    };

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="table-responsive">
                            <div className="card">
                                <div className="col-md-12">
                                    <div className="card-header">
                                        <div className="py-3 d-flex justify-content-between align-items-center">
                                            <h5>Internship Supervisor - Discipline Mapping  </h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div className="card-body">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-12 mb-4">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label>Admission Year <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    // menuPlacement="auto"
                                                                    id="admyear"
                                                                    name="admyear"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    options={admissionYears}
                                                                    value={admissionYear}
                                                                    onChange={handleAdmissionYearChange}
                                                                />
                                                            </div>

                                                            <div className="col-md-6">
                                                                <label>Semester <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    // menuPlacement="auto"
                                                                    id="semester_id"
                                                                    name="semester_id"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    options={[
                                                                        { value: 4, label: '4' },
                                                                        // { value: 5, label: '5' }
                                                                    ]}
                                                                    value={semester_id}
                                                                    onChange={handleSemesterChange}
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-10 stat-out-bod">
                                                            <table
                                                                className="table-striped table-bordered ex-table mb-10"
                                                                ref={tableRef}
                                                                id="dataTableBos"
                                                                width="100%"
                                                                style={{ textAlign: 'center', tableLayout: 'fixed' }}
                                                            >
                                                                <thead>
                                                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Total Disciplines
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Mapped Disciplines-Pending For Principal Approval
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Disciplines Pending Mapping
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Principal Approved Mapping
                                                                        </th>
                                                                    </tr>

                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>{getISDisciplineCounts?.total_disciplines ? getISDisciplineCounts.total_disciplines : '0'}</td>
                                                                        <td>{getISDisciplineCounts?.mapped_count ? getISDisciplineCounts.mapped_count : '0'}</td>
                                                                        <td>{getISDisciplineCounts?.not_mapped_count ? getISDisciplineCounts.not_mapped_count : '0'}</td>
                                                                        <td>{getISDisciplineCounts?.approved_count ? getISDisciplineCounts.approved_count : '0'}</td>

                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>

                                                    {admissionYear && semester_id ? (
                                                        disciplinedata && disciplinedata.length > 0 ? (
                                                            <div>


                                                                <div className="row mt-2">

                                                                    <div className="row mt-2 align-items-center">

                                                                        {/* LEFT SIDE BUTTON */}
                                                                        <div className="col-md-8">
                                                                            {selectedDisciplines.length > 0 && (

                                                                                <button
                                                                                    className="btn btn-primary"
                                                                                    type="submit"
                                                                                    onClick={() => setShowModal(true)}
                                                                                >
                                                                                    Approve Selected Disciplines ({selectedDisciplines.length})
                                                                                </button>
                                                                            )}
                                                                        </div>

                                                                        {/* RIGHT SIDE DOWNLOAD BUTTON */}
                                                                        <div className="col-md-4 text-end">
                                                                            <button
                                                                                className="lbl2 btn btn-primary"
                                                                                onClick={() => handleGeneratePDFNew()}
                                                                                title="Download"
                                                                            >
                                                                                <i className="bi bi-arrow-down-square"></i>
                                                                            </button>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                <table className="table colap-table table-hover table-striped">
                                                                    <thead style={{ backgroundColor: "#f8f9fa", color: "#000" }}>
                                                                        <tr style={{ textAlign: "center" }}>
                                                                            <th className="bg-primary" scope="col" width="8%">
                                                                                {Array.isArray(disciplinedata) && disciplinedata.length > 0 && disciplinedata.some(row => row.mapped === "mapped") && (
                                                                                    <input id="select-all" type="checkbox"
                                                                                        onChange={handleSelectAll}
                                                                                        checked={isSelectAllChecked} />
                                                                                )}

                                                                            </th>
                                                                            <th className="bg-primary" width="50%">Disciplines</th>
                                                                            <th className="bg-primary">Name - UMS ID- Phone No.</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>

                                                                        {disciplinedata.map((discipline) => {

                                                                            // Determine display text and styling
                                                                            let displayText = "Not Mapped";
                                                                            let textColor = "#856404"; // default for Not Mapped
                                                                            let bgColor = "#fff3cd"; // default for Not Mapped
                                                                            let borderColor = "#ffeeba"; // default for Not Mapped

                                                                            if (discipline.mapped === "approved") {

                                                                                displayText = "Approved Mapping";
                                                                                textColor = "#155724"; // green
                                                                                bgColor = "#d4edda";
                                                                                borderColor = "#c3e6cb";

                                                                            } else if (discipline.mapped === "mapped") {

                                                                                displayText = "Mapped";
                                                                                textColor = "#004085"; // blue for mapped but not approved
                                                                                bgColor = "#cce5ff";
                                                                                borderColor = "#b8daff";
                                                                            }

                                                                            return (
                                                                                <tr key={discipline.discipline_id} style={{ textAlign: "center", verticalAlign: "middle", borderBottom: "1px solid #ddd" }}>
                                                                                    <td>
                                                                                        {discipline.mapped === 'mapped' ? (
                                                                                            <input type="checkbox" class="text-center" value={discipline.discipline_id}
                                                                                                checked={selectedDisciplines.includes(discipline.discipline_id)}
                                                                                                onChange={() => handleCheckboxChange(discipline.discipline_id)} />
                                                                                        ) : discipline.mapped === 'Not Mapped' ? (

                                                                                            <span class="badge badge-danger text-white rounded-pill"><i class="fa fa-times" aria-hidden="true"></i></span>

                                                                                        ) : discipline.mapped === 'approved' && (

                                                                                            <span class="badge badge-success text-white rounded-pill"><i class="fa fa-check" aria-hidden="true"></i></span>


                                                                                        )}
                                                                                    </td>
                                                                                    <td>
                                                                                        <input
                                                                                            type="text"
                                                                                            id={`discipline_id_${discipline.discipline_id}`}
                                                                                            name={`discipline_id_${discipline.discipline_id}`}
                                                                                            className="form-control ht"
                                                                                            value={discipline.discipline_name}
                                                                                            readOnly
                                                                                        />

                                                                                        <div
                                                                                            style={{
                                                                                                marginTop: "5px",
                                                                                                fontSize: "12px",
                                                                                                padding: "3px 8px",
                                                                                                borderRadius: "4px",
                                                                                                display: "inline-block",
                                                                                                color: textColor,
                                                                                                backgroundColor: bgColor,
                                                                                                border: `1px solid ${borderColor}`
                                                                                            }}
                                                                                        >
                                                                                            {displayText}
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <Select
                                                                                            id={`user_id_${discipline.discipline_id}`}
                                                                                            name={`user_id_${discipline.discipline_id}`}
                                                                                            maxMenuHeight={200}
                                                                                            menuPlacement="auto"
                                                                                            styles={customStyles}
                                                                                            className="form-control ht"

                                                                                            options={getCollegeTeacherData.map(user => ({
                                                                                                value: user.user_id,
                                                                                                label: `${user.full_name} - ${user.fac_id} - ${user.mobile_number}`,
                                                                                                fac_id: user.fac_id,
                                                                                            }))}
                                                                                            value={selectedUserOptions[discipline.discipline_name] || null}
                                                                                            isMulti
                                                                                            isDisabled={true}

                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </table>

                                                                {selectedDisciplines.length > 0 && (

                                                                    <div className="col-md-12 txt-aln p-50">
                                                                        <div>
                                                                            <button
                                                                                className="btn btn-primary me-3"
                                                                                type="submit"
                                                                                onClick={() => setShowModal(true)}
                                                                            >
                                                                                Approve Selected Disciplines ({selectedDisciplines.length})
                                                                            </button>


                                                                        </div>
                                                                    </div>


                                                                )}




                                                            </div>
                                                        ) : (
                                                            <div style={{ textAlign: 'center' }}>
                                                                <p>No data found</p>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div style={{ textAlign: 'center' }}>
                                                            <p>No data found</p>
                                                        </div>
                                                    )}

                                                    <div className={`modal fade show ${ShowModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                                            <div className="modal-content">
                                                                <div className="modal-body">
                                                                    <div className="modal-toggle-wrapper">
                                                                        <h4 className="text-center pb-2">Are you sure you want to Approve?</h4>
                                                                        <p className="txt-aln-jst">This action will approve the submitted data and cannot be undone.</p>
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <div>
                                                                                <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Approve</button>
                                                                                <button
                                                                                    className="btn"
                                                                                    style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                                                    data-bs-dismiss="modal"
                                                                                    onClick={handleCancel}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




            </Template>
        </>
    );
}
